/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import { DynamicLocalizationContext } from "@/context";
import { Avatar as CoreAvatar } from "./avatar";
import { Accordion as CoreAccordion } from "./accordion";
import { AreYouSureDialog as CoreAreYouSureDialog } from "./are-you-sure-dialog";
import { Backdrop as CoreBackdrop } from "./backdrop";
import { Badge as CoreBadge } from "./badge";
import { Box as CoreBox } from "./box";
import { Breadcrumbs as CoreBreadcrumbs } from "./breadcrumbs";
import { Button as CoreButton } from "./button";
import { Card as CoreCard } from "./card";
import { Currency as CoreCurrency } from "./currency";
import { DataTable as CoreDataTable } from "./data-table";
import { GoogleMap as CoreGoogleMap } from "./google-map";
import { Dialog as CoreDialog } from "./dialog";
import { Divider as CoreDivider } from "./divider";
import { DragDrop as CoreDragDrop } from "./drag-drop";
import { Forbidden as CoreForbidden } from "./errorPages";
import { Form as CoreForm } from "./form";
import { Select as CoreFormSelect } from "./form/form-fields/select";
import { TextField as CoreFormTextField } from "./form/form-fields/text-field";
import { CodeVerification as CoreFormCodeVerification } from "./form/form-fields/code-verification";
import { DatePicker as CoreFormDatePicker } from "./form/form-fields/date-picker";
import { Label as CoreFormLabel } from "./form/form-fields/label";
import { Switch as CoreFormSwitch } from "./form/form-fields/switch";
import { Checkbox as CoreFormCheckbox } from "./form/form-fields/checkbox";
import { AutoComplete as CoreFormAutoComplete } from "./form/form-fields/auto-complete";
import { PhoneNumber as CoreFormPhoneNumber } from "./form/form-fields/text-field/phone-number";
import { Radio as CoreFormRadio } from "./form/form-fields/radio";
import { FormSkeletonLoading as CoreFormSkeletonLoading } from "./form-skeleton-loading";
import { Grid as CoreGrid } from "./grid";
import { GridItem as CoreGridItem } from "./grid/grid-item";
import { IconButton as CoreIconButton } from "./icon-button";
import { Image as CoreImage } from "./image";
import { KeyValue as CoreKeyValue } from "./key-value";
import { Link as CoreLink } from "./link";
import { LocaleToggle as CoreLocaleToggle } from "./locale-toggle";
import { Menu as CoreMenu, MenuItem as CoreMenuItem } from "./menu";
import { Meta as CoreMeta } from "./meta";
import { Popover as CorePopover } from "./popover";
import { Tabs as CoreTabs, TabPanel as CoreTabPanel } from "./tabs";
import { Typography as CoreTypography } from "./typography";
import { PageWrapper as CorePageWrapper } from "./wrapper-page";
import { Skeleton as CoreSkeleton } from "./skeleton";
import { Stepper as CoreStepper } from "./stepper";
import { Step as CoreStep } from "./stepper/step";
import { SlideShow as CoreSlideShow } from "./slide-show";
import CoreSlide from "./slide-show/slide";
import { Carousel as CoreCarousel } from "./carousel";
import { Video as CoreVideo } from "./video";

export const Avatar = CoreAvatar;
export const Accordion = CoreAccordion;
export const AreYouSureDialog = CoreAreYouSureDialog;
export const Backdrop = CoreBackdrop;
export const Badge = CoreBadge;
export const Box = CoreBox;
export const Breadcrumbs = CoreBreadcrumbs;
export const Button = CoreButton;
export const Card = CoreCard;
export const Carousel = CoreCarousel;
export const Currency = CoreCurrency;
export const DataTable = CoreDataTable;
export const GoogleMap = CoreGoogleMap;
export const Dialog = CoreDialog;
export const Divider = CoreDivider;
export const DragDrop = CoreDragDrop;
export const Forbidden = CoreForbidden;
export const Form = CoreForm;
export const Select = CoreFormSelect;
export const TextField = CoreFormTextField;
export const CodeVerification = CoreFormCodeVerification;
export const PhoneNumber = CoreFormPhoneNumber;
export const DatePicker = CoreFormDatePicker;
export const Label = CoreFormLabel;
export const Switch = CoreFormSwitch;
export const Checkbox = CoreFormCheckbox;
export const AutoComplete = CoreFormAutoComplete;
export const Radio = CoreFormRadio;
export const FormSkeletonLoading = CoreFormSkeletonLoading;
export const Grid = CoreGrid;
export const GridItem = CoreGridItem;
export const IconButton = CoreIconButton;
export const Image = CoreImage;
export const Link = CoreLink;
export const LocaleToggle = CoreLocaleToggle;
export const Menu = CoreMenu;
export const MenuItem = CoreMenuItem;
export const Meta = CoreMeta;
export const Popover = CorePopover;
export const Tabs = CoreTabs;
export const TabPanel = CoreTabPanel;
export const Typography = CoreTypography;
export const PageWrapper = CorePageWrapper;
export const Skeleton = CoreSkeleton;
export const Stepper = CoreStepper;
export const Step = CoreStep;
export const SlideShow = CoreSlideShow;
export const Slide = CoreSlide;
export const KeyValue = CoreKeyValue;
export const Video = CoreVideo;

export function DynamicLocalization({ value, children }: any) {
  return (
    <DynamicLocalizationContext.Provider value={value}>
      {children}
    </DynamicLocalizationContext.Provider>
  );
}

DynamicLocalization.propTypes = {
  value: PropTypes.object,
  children: PropTypes.any,
};
